import { render, staticRenderFns } from "./DataTableExpo.vue?vue&type=template&id=766506c0&"
import script from "./DataTableExpo.vue?vue&type=script&lang=js&"
export * from "./DataTableExpo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports